/**
 * group.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

import { Rule } from "../permissions/rules";
import { User } from "./user";

/** 
 * {@link GroupData} is the shape of {@link Group} information as communicated
 * across the websocket protocol.
 */
export interface GroupData {
  groupName : string;
  groupId : number;
  rules? : Rule[];
  isPrimary: boolean;
  primaryGroupId : number;
}

/**
 * A {@link Group} is a the primary siloing and security structure for the
 * application. Most entities belong to one or more groups. Users can only
 * access data if they share at least one group with that data, as well as
 * have a 
 * 
 */
export class Group
{
  public name : string;
  public id : number;
  public rules : Rule[] = [];
  public users : User[] = [];

  public primaryGroupId : number | null;
  public get isPrimary () : boolean
  {
	  return this.primaryGroupId === this.id;
  }
  public primaryGroup : Group | null;

  public constructor (data : GroupData, self? : User)
  {
    this.name = data.groupName;
    this.id = data.groupId;
	this.rules = data.rules || [];
	this.primaryGroupId =
		(data.primaryGroupId === -1) ? null : data.primaryGroupId;
	if (self)
	{
		this.users.push(self);
	}
  }

  /**
   * Determine if this group allows a set of permission {@link Rule}s.
   * @param rules The Rule or Rules to check against this group
   * @param disjunctive Whether to check a list of rules as a disjunction
   */
  public allows (rules : Rule[] | Rule, disjunctive : boolean = false) : boolean
  {
    if (!Array.isArray(rules))
    {
      return (this.rules.indexOf(rules) > -1);
    }
    if (disjunctive)
    {
      return rules.some((r : Rule) => this.rules.indexOf(r) > -1);
    }
    else
    {
      return rules.every((r : Rule) => this.rules.indexOf(r) > -1);
    }
  }

  /**
   * Is the current user a member of this group?
   */
  public get member () : boolean
  {
	  return this.rules.length > 0;
  }
}

export class ManagedGroup extends Group
{
	
}


// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/auth/identity/group.ts